import { FeatureTourDefinition, FeatureTourStep } from '@/featureTour/types/featureTour';

export interface FeatureTourState {
	isActive: boolean;
	activeTour: FeatureTourDefinition | null;
	activeStepIndex: number;
	activeStep: FeatureTourStep | null;
	targetElement: HTMLElement | null;
	targetRect: DOMRect | null;
	// 1-based position of the currently visible step among only the steps
	// that are eligible to display (skipped steps don't count). The tour card
	// uses this for "Step 0X" so users see continuous numbering even when some
	// steps were filtered out for the current tool/page.
	displayStepIndex: number;
	// Total number of steps that will actually be shown — the raw
	// activeTour.steps.length minus any indices we've discovered to be hidden.
	displayTotalSteps: number;
}

const initialState = (): FeatureTourState => ({
	isActive: false,
	activeTour: null,
	activeStepIndex: -1,
	activeStep: null,
	targetElement: null,
	targetRect: null,
	displayStepIndex: 0,
	displayTotalSteps: 0,
});

// Single PATCH/RESET mutation pair keeps the diff in featureTourService.ts
// minimal — most state writes there change one or two fields at a time.
export default {
	namespaced: true,
	state: initialState() as FeatureTourState,
	mutations: {
		PATCH (state: FeatureTourState, payload: Partial<FeatureTourState>) {
			Object.assign(state, payload);
		},
		RESET (state: FeatureTourState) {
			Object.assign(state, initialState());
		},
	},
};
